module.exports = __webpack_public_path__ + "img/HongKong.bc6a98b3.svg";